export default __webpack_public_path__ + "static/media/respuestaoficioIconosbarra-01.726b1984.png";